





























import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class ActivitySlider extends Vue {
  @Getter("groupSliderList") getterGroupSliderList!: Array<string>;

  tempSliderList: Array<object> = [];
  currentIndex: number = 0;

  get groupSliderList(): Array<string> {
    const tempArray: Array<string> = this.getterGroupSliderList.filter(item => {
      if (item) return item;
    });

    if (tempArray.length === 1) {
      tempArray.push(tempArray[0]);
      tempArray.push(tempArray[0]);
      tempArray.push(tempArray[0]);
    } else if (tempArray.length === 2) {
      tempArray.push(tempArray[0]);
      tempArray.push(tempArray[1]);
    } else if (tempArray.length === 3) {
      tempArray.push(tempArray[1]);
    }
    return tempArray;
  }

  mounted() {
    let timer: number;
    const sliderDom = document.getElementsByClassName(
      "activity-slider-block"
    )[0];
    let startPos = 0;
    sliderDom.addEventListener("touchstart", (e: Event) => {
      e.preventDefault();
      startPos = (e as any).touches[0].clientX;
    });

    sliderDom.addEventListener("touchend", (e: Event) => {
      e.preventDefault();
      const endPos = (e as any).changedTouches[0].clientX;
      if (endPos - startPos > 10) {
        window.clearInterval(timer);
        this.currentIndex =
          (this.currentIndex - 1 + this.groupSliderList.length) %
          this.groupSliderList.length;
        timer = window.setInterval(this.autoRoll, 5000);
      }
      if (endPos - startPos < -10) {
        window.clearInterval(timer);
        this.currentIndex =
          (this.currentIndex + 1) % this.groupSliderList.length;
        timer = window.setInterval(this.autoRoll, 5000);
      }
    });

    timer = window.setInterval(this.autoRoll, 5000);
  }

  autoRoll() {
    this.currentIndex = (this.currentIndex + 1) % this.groupSliderList.length;
  }
}
